import {LovValueSummary} from '../../../common/lov/lov-value/api/model/lovValueSummary.model';
import {DocumentSummaryModel} from '../../../document/common/api/model/documentSummary.model';
import {SummaryModel} from '../../../common/entity/summary.model';
import {PermissionsModel} from '../../../common/entity/permissions.model';

export class ProductSummaryModel implements SummaryModel {
    id: number;
    code: string;
    invoiceLabel: string;
    label: string;
    description: string;
    priceVatExcluded: number;
    priceVatIncluded: number;
    taxPercentage: number;
    active: boolean;
    category: LovValueSummary;
    type: LovValueSummary;
    image: DocumentSummaryModel;
    permissions: PermissionsModel;
    hasStock: boolean;
    stock: number;
    advanceVatIncluded: number;
    advanceVatExcluded: number;
    color: LovValueSummary;
}
